var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define('views/navigation/NavigationView',['require','underscore','reactDOM','ET/ETView','modules/layout/header','modules/layout/nav','views/navigation/SubHeaderView','views/navigation/GuideView','views/navigation/OrganizationView'],function(require) {
  var ETView, GuideView, Header, Nav, NavigationView, OrganizationView, ReactDOM, SubHeaderView, _;
  _ = require("underscore");
  ReactDOM = require("reactDOM");
  ETView = require("ET/ETView");
  Header = require("modules/layout/header");
  Nav = require("modules/layout/nav");
  SubHeaderView = require("views/navigation/SubHeaderView");
  GuideView = require("views/navigation/GuideView");
  OrganizationView = require("views/navigation/OrganizationView");
  return NavigationView = (function(_super) {
    __extends(NavigationView, _super);

    function NavigationView() {
      return NavigationView.__super__.constructor.apply(this, arguments);
    }

    NavigationView.prototype.initialize = function() {
      this.views = {};
      return this.views.OrganizationView = new OrganizationView;
    };

    NavigationView.prototype.start = function() {
      this.views.SubHeaderView = new SubHeaderView;
      this.views.GuideView = new GuideView;
      return this.enable();
    };

    NavigationView.prototype.enable = function() {
      if (this.enabled) {
        return;
      }
      ReactDOM.render(Header(), document.getElementById("header"));
      ReactDOM.render(Nav(), document.getElementById("nav"));
      _.each(this.views, function(val, key) {
        val.$el.show();
        if (key === "OrganizationView") {
          return val.$el.attr("style", null);
        }
      });
      return this.enabled = true;
    };

    NavigationView.prototype.destroy = function() {
      ReactDOM.unmountComponentAtNode(document.getElementById("header"));
      ReactDOM.unmountComponentAtNode(document.getElementById("nav"));
      _.each(this.views, function(view) {
        view.$el.empty().remove();
        return view.destroy();
      });
      this.views = {};
      this._destroy();
      return this.enabled = false;
    };

    return NavigationView;

  })(ETView);
});

//# sourceMappingURL=NavigationView.js.map
;
